module.exports = __webpack_public_path__ + "img/qlcjy_charact_2.05ee35d4.svg";